import swal from 'sweetalert2'

/**
 * 我们这里将 sweetalert2 封装成一个插件，Vue.js 的插件有一个公开方法 install ，这个方法的第一个参数是 Vue 构造器。
 * 将 swal 添加成全局方法和实例的方法后，我们就能通过 Vue.swal 和 this.$swal 进行访问
 */
export default {
  install: (Vue) => {
    // sweetalert2 的设置默认配置的方法
    swal.setDefaults({
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'rgb(140,212,245)',
      cancelButtonColor: 'rgb(193,193,193)'
    });

    // 添加全局方法
    Vue.swal = swal
    // 添加实例方法
    Vue.prototype.$swal = swal
  }
}
